import { routePlanApis } from '@apis/dashboard/routePlanApis';
import { useMutation } from '@hooks/useMutation';
import { PostRoutePlan } from '@models/RoutePlan';
import { useQueryClient } from '@tanstack/react-query';

export const usePostRoutePlan = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async (body: PostRoutePlan) => {
      const response = await routePlanApis.post('/dashboard/route-plan/', {
        body,
      });

      return response[201]!;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['/dashboard/route-plan/']);
      },
    },
  );
};
